import React,{ useState,}from 'react'
import { Modal,Form,message, Input} from 'antd';
import { useBnsMeiJieWenDangAddMutation } from '../../store/ReactWebSiteApi';
import MyEditor from '../../cpn/MyEditor';
function DocAdd(props) {    
    const [form] = Form.useForm();
    const [open, setOpen] = useState(false);   
    const [add]  = useBnsMeiJieWenDangAddMutation()
    const [info,setInfo] = useState({bbb_bg_id:''});
    return (
            <>
                <a
                    onClick={() => {setOpen(true)}}
                >新增</a>
                <Modal
                    width={1000}
                    open={open}
                    title='新增文件'
                    okText="提交"
                    cancelText="取消"
                    onCancel={() => {setOpen(false);}}
                    onOk={() => {
                        form
                            .validateFields()
                            .then((values) => {
                                form.resetFields();  
                                add({
                                    "bmjwd_bmj_id" : props.bmj_id,
                                    "bmjwd_cid" : localStorage.getItem('eu_id'),
                                    "bmjwd_cname" : localStorage.getItem('eu_name'),
                                    "bmjwd_content" : info.bmjwd_content,
                                    "bmjwd_dept_id" : props.bmj_dept_id,
                                    "bmjwd_dept_name" : props.bmj_dept_name,
                                    "bmjwd_e_id" : localStorage.getItem('e_id'),
                                    "bmjwd_name" : info.bmjwd_name,           
                                }).then((res) => {
                                    if (res.data.Status === 'success') {
                                        message.info('新增成功！');
                                        setOpen(false);
                                    }
                                    if (res.data.Status === "fail") {
                                        message.error('新增失败！'+res.data.Message)
                                    }
                                })                        
                            })
                            .catch((info) => {
                                console.log('Validate Failed:', info);
                            });                    
                    }}
                >
                    <Form
                        form={form}
                        layout="horizonal"
                        name="form_client_add"
                        initialValues={{modifier: 'public',}}
                        labelCol={{ span: 3 }}
                    >
                        <Form.Item name="name" label='名称' wrapperCol={{span:20}} required>
                            <Input 
                                onChange={(e) => {setInfo(prevState=>({...prevState,bmjwd_name:e.target.value}))}}
                            />
                        </Form.Item>     
                        <Form.Item
                            label='备注'
                            wrapperCol={{span:20}}
                        >
                            <MyEditor  onChange={(e) => {setInfo(prevState=>({...prevState,bmjwd_content:e}))}}/>
                        </Form.Item>   
                    </Form>
                </Modal>
            </>
        )
}

export default DocAdd